export default __webpack_public_path__ + "static/media/15.949cff95.jpg";